import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export const CookiePage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-356">
      <SEO title="Cookieverklaring - Blue Rain Productions" description="Informatie over hoe Blue Rain Productions cookies gebruikt. Lees welke cookies we gebruiken en waarom, en hoe u uw cookie-instellingen kunt beheren." data-id="element-357" />
      <Navbar data-id="element-358" />
      <main data-id="element-359">
        <section className="py-32 bg-gradient-to-b from-black to-gray-950 w-full" data-id="element-360">
          <div className="container mx-auto px-4 md:px-6" data-id="element-361">
            <h1 className="text-4xl md:text-6xl font-bold mb-8 text-center" data-id="element-362">
              Cookieverklaring
            </h1>
            <div className="max-w-4xl mx-auto mt-12 mb-16" data-id="element-363">
              <div className="prose prose-invert prose-lg" data-id="element-364">
                <p className="text-gray-300 mb-6" data-id="element-365">
                  Blue Rain Productions maakt gebruik van cookies op onze
                  website. In deze cookieverklaring leggen we uit wat cookies
                  zijn, welke cookies we gebruiken en waarom, en hoe u uw
                  cookie-instellingen kunt beheren.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-366">
                  Wat zijn cookies?
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-367">
                  Cookies zijn kleine tekstbestanden die worden opgeslagen op uw
                  computer of mobiele apparaat wanneer u een website bezoekt. Ze
                  worden veel gebruikt om websites efficiënter te laten werken
                  en om informatie te verstrekken aan de eigenaren van de
                  website.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-368">
                  Welke cookies gebruiken wij?
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-369">
                  Wij gebruiken de volgende soorten cookies:
                </p>
                <h3 className="text-xl font-semibold mt-6 mb-3 text-white" data-id="element-370">
                  Noodzakelijke cookies
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-371">
                  Deze cookies zijn essentieel om u in staat te stellen door de
                  website te navigeren en de functies te gebruiken. Zonder deze
                  cookies kunnen bepaalde delen van onze website niet
                  functioneren.
                </p>
                <h3 className="text-xl font-semibold mt-6 mb-3 text-white" data-id="element-372">
                  Functionele cookies
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-373">
                  Deze cookies stellen de website in staat om verbeterde
                  functionaliteit en personalisatie te bieden. Ze kunnen worden
                  ingesteld door ons of door externe providers wiens diensten we
                  hebben toegevoegd aan onze pagina's.
                </p>
                <h3 className="text-xl font-semibold mt-6 mb-3 text-white" data-id="element-374">
                  Analytische cookies
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-375">
                  Deze cookies verzamelen informatie over hoe bezoekers onze
                  website gebruiken, bijvoorbeeld welke pagina's ze het meest
                  bezoeken en of ze foutmeldingen krijgen. Deze cookies
                  verzamelen geen informatie die een bezoeker identificeert.
                </p>
                <h3 className="text-xl font-semibold mt-6 mb-3 text-white" data-id="element-376">
                  Marketing cookies
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-377">
                  Deze cookies worden gebruikt om bezoekers op websites te
                  volgen. De bedoeling is om advertenties weer te geven die
                  relevant en aantrekkelijk zijn voor de individuele gebruiker
                  en daardoor waardevoller voor uitgevers en externe
                  adverteerders.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-378">
                  Hoe kunt u cookies beheren?
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-379">
                  De meeste webbrowsers staan toe dat u cookies beheert via de
                  instellingen van uw browser. Dit kan het blokkeren van cookies
                  omvatten of het verwijderen van cookies die al zijn opgeslagen
                  op uw apparaat. Als u ervoor kiest om alle cookies te
                  blokkeren, werken sommige delen van onze website mogelijk niet
                  correct.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-380">
                  Wijzigingen in onze cookieverklaring
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-381">
                  We kunnen deze cookieverklaring van tijd tot tijd bijwerken.
                  Eventuele wijzigingen zullen op deze pagina worden geplaatst.
                  We raden u aan om deze pagina regelmatig te controleren om op
                  de hoogte te blijven van eventuele wijzigingen.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-382">
                  Contact
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-383">
                  Als u vragen heeft over onze cookieverklaring, neem dan
                  contact met ons op via:
                </p>
                <p className="text-gray-300 mb-6" data-id="element-384">
                  E-mail: info@bluerainproductions.nl
                  <br data-id="element-385" />
                  Telefoon: +31651764541
                </p>
                <p className="text-gray-400 mt-10 text-sm" data-id="element-386">
                  Laatste update:{' '}
                  {new Date().toLocaleDateString('nl-NL', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-387" />
    </div>;
};